import * as Sentry from "@sentry/react";

if(import.meta.env.DEV) {
  console.log("Sentry is disabled in development mode.");
  Sentry.init({
    enabled: false
  });
} else {
  Sentry.init({
    dsn: "https://38bf8504046114f281117126ac40d715@o1197382.ingest.us.sentry.io/4509168459186176",
    tracesSampleRate: 0.0,
    replaysSessionSampleRate: 0.0,
    replaysOnErrorSampleRate: 0.0
  });
}

export default Sentry;